import {Grid, useTheme} from "@mui/material";
import DealMenu from "../components/DealMenu";
import {Item} from "../../../domains/common/components/Item";
import RealtyFormContainer from "../components/Realty";
import {EnteringInfoActionType, RolesEnums} from "../../../enums";
import {FilesListContainer} from "../components/FilesContainer";
import {XmlList} from "../components/XmlList";
import React, {useState} from "react";
import {FormInput, FormInputDate, Textarea} from "../../../domains/common/components/FormInput";
import {Responsible} from "../components/Responsible";
import {enteringInfoActionType} from "../../../dictionaries";
import FormSelect from "../../../domains/common/components/FormSelect";
import {dealData} from "../deal";
import {waitInputComplete} from "../../../fn";
import {ParticipantsComponent} from "../components/Participants";
import { ChildStatmentContainer } from "../components/ChildStatement";
import DealCommentContainer from "../components/Comment";
/**
 * Тип сделки
 * @returns {Element}
 * @constructor
 */
export function DealEnteringInfoToEGRN() {
  const theme = useTheme();

  return (
    <Grid container spacing={1} sx={{ mt: 0.2 }}>
      <Grid item xs={12}>
        <DealMenu dealId={dealData.dealId}></DealMenu>
      </Grid>
      <Grid item xs={12}>
        <Item sx={{backgroundColor: theme.palette.background.default}}>
          <RealtyFormContainer values={dealData.realty}/>
        </Item>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <ParticipantsComponent role={RolesEnums.DECLARANT} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <FilesListContainer />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <XmlList value={dealData?.dealXmlStatementsList} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <Responsible value={dealData.user} />
            </Item>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <ParticipantsComponent role={RolesEnums.REPRESENTATIVE} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <ParticipantsComponent role={RolesEnums.EXT_SIGNER} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <ChildStatmentContainer />
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <DealCommentContainer />
            </Item>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export function EnteringInfoParamsContainer({onChange}) {
  const [state, setState] = useState(dealData.deal);

  const handleChangeActionType = (e) => {
    onChange ? onChange({'enteringInfoActionType': e.target.value}) : void 0;

    setState({...dealData, ...{'enteringInfoActionType': e.target.value}})
  }

  const handleChange = (e) => {
    onChange ? onChange({[e.target.name]: e.target.value}) : void 0;
  }

  const changeDescCont = <Textarea label="Описание изменений" name="changesDescription"
                                   multiline={true} rows={3} value={state?.changesDescription}
                                   onChange={waitInputComplete((e) => onChange({changesDescription: e.target.value}), 1500)}/>

  const borderRecordNumberCont = (<FormInput label="Реестровый номер границы"  name="borderRecordNumber" onChange={waitInputComplete((e) => handleChange(e), 1500)} value={state?.borderRecordNumber}/>);

  const regDatasCont = (<Grid container>
      <Grid item xs={12}>
        <FormInputDate label="Дата внесения записи реестра"
          name="regDate"
                       onChange={(value) => onChange ? onChange({regDate: value}) : void 0}
                       value={state?.regDate}/>
      </Grid>
      <Grid item xs={12} sx={{height: 12}}></Grid>
      <Grid item xs={12}>
        <FormInput label="Номер записи реестра"
          name="regNumber"
          fullWidth={400}
          onChange={waitInputComplete((e) => handleChange(e), 1500)}
                   value={state?.regNumber}/>
      </Grid>
    </Grid>);

  const errRecordCont = (
    <Grid container>
      <Grid item xs={12}>
      <Textarea label="Ошибочная запись" name="errRecord"
                multiline={true} rows={2} value={state?.errRecord}
                onChange={waitInputComplete((e) => handleChange(e), 1500)}/>
      <Grid item xs={12} sx={{height: 12}}></Grid>
      <Textarea label="Корректная запись" name="corrRecord"
                multiline={true} rows={2} value={state?.corrRecord}
                onChange={waitInputComplete((e) => handleChange(e), 1500)}/>
      </Grid>
    </Grid>);

  return (
    <Grid container>
      <Grid item xs={6}>
        <Grid container>
          <Grid item xs={12}>
            <FormSelect name="enteringInfoActionType"
                        data={enteringInfoActionType} label="Тип действия" minWidth={250}
                        maxWidth={450} value={state?.enteringInfoActionType}
                        onChange={handleChangeActionType}/>
          </Grid>
          <Grid item xs={12} sx={{height: 12}}></Grid>
          <Grid item xs={12}>
            {state?.enteringInfoActionType === EnteringInfoActionType.BORDER_ERROR_ACTION ? borderRecordNumberCont : void 0}
            {state?.enteringInfoActionType === EnteringInfoActionType.REGISTRY_ERROR_ACTION ? regDatasCont : void 0}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container>
          <Grid item xs={12}>
            {state?.enteringInfoActionType === EnteringInfoActionType.REGISTRY_CHANGE_ACTION ? changeDescCont : void 0}
            {[EnteringInfoActionType.BORDER_ERROR_ACTION, EnteringInfoActionType.REGISTRY_ERROR_ACTION].includes(state?.enteringInfoActionType) ? errRecordCont : void 0}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}